import type { SkuBenchmark } from '../../data/analytics';
import type { ApiDetail, Endpoint } from '../../features/catalog/model';
import { aggregateBenchmarks } from '../../lib/benchmarks';
import { endpointAnswer } from '../../lib/seo/endpointAnswer';
import { FaqBand } from '../../components/editorial/FaqBand';
import { m } from '../../paraglide/messages';

/**
 * Bottom-of-page FAQ for one endpoint page, the sibling of ApiFaq on the
 * platform page above it.
 *
 * It sits below the routing table and the request console for the same reason
 * ApiFaq sits below the endpoint list: the price and the call are what someone
 * landing here came to read, and prose in front of them pushes the page down
 * to say what the table already shows. The passage is not for that reader. It
 * is for the extractor that cannot read the table at all.
 */
export const EndpointFaq = ({
  api,
  endpoint,
  benchmarks,
}: {
  api: ApiDetail;
  endpoint: Endpoint;
  benchmarks: Record<string, SkuBenchmark>;
}) => {
  const skus = [endpoint.sku];
  const answer = endpointAnswer(api, endpoint, aggregateBenchmarks(skus, benchmarks));
  if (!answer) return null;

  return (
    <FaqBand
      heading={m.endpoint_faq_heading({ platform: api.name, action: endpoint.action })}
      lede={answer.passage}
      questions={answer.questions}
    />
  );
};
